const getters = {
  // employeeNo: state => state.user.employeeNo,
  // employeeName: state => state.user.employeeName,
}
export default getters
